import { useForm } from 'react-hook-form';
import { useState } from 'react';
import { catchErrorMessage } from 'utility/helpers';
import { toast } from 'react-toastify';
import useUserData from 'hooks/useUserData';
import InsightAPI from 'api/InsightAPI';
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import { AttachmentType } from '@buildwise/pages/knowledge/hooks/useArticlesQuery';

export type FeedbackFormData = {
  description: string;
  attachments?: AttachmentType[] | undefined;
};

const useFeedbackForm = (afterSubmit: () => void) => {
  const { company, user } = useUserData();

  const feedbackForm = useForm<FeedbackFormData>({
    resolver: yupResolver(
      Yup.object().shape({
        description: Yup.string().required('This is a required field'),
      }),
    ),
    defaultValues: { description: '', attachments: [] },
  });
  const {
    handleSubmit,
    reset,
    trigger,
    formState: { isSubmitting },
  } = feedbackForm;

  const onSubmit = async (values: FeedbackFormData) => {
    try {
      trigger();
      if (!values.description) return null;
      const payload = {
        title: `${company?.name}; ${user?.userNameToDisplay}; ${user?.title}`,
        description: values.description,
      };

      const formData = new FormData();
      formData.append('article', JSON.stringify(payload));

      if (values.attachments?.length) {
        for (let i = 0; i < values?.attachments?.length; i++) {
          const { file, thumbnail } = values?.attachments?.[i];
          if (file) {
            formData.append('file', file);
          }
          if (thumbnail) {
            formData.append('thumbnail', thumbnail);
          }
        }
        await InsightAPI.feedback(formData);
      } else {
        await InsightAPI.feedback(formData);
      }

      toast.success('Feeback saved successfully');
      reset();
      afterSubmit();
    } catch (e) {
      toast.error(catchErrorMessage(e));
    }
  };

  const triggerSubmit = handleSubmit(onSubmit);

  return {
    feedbackForm,
    triggerSubmit,
    isSubmitting,
  };
};

export default useFeedbackForm;
